import { useCloseOnBackButton } from "@/hooks/ui/use-close-on-back-button";
import { memo, ReactNode } from "react";
import { createPortal } from "react-dom";

interface RoundedModalProps {
  isOpen: boolean;
  onDidDismiss: () => void;
  backdropDismiss?: boolean;
  children: ReactNode;
  width?: string;
  maxWidth?: string;
  borderRadius?: string;
}

export const RoundedModal = memo(function RoundedModal({
  isOpen,
  onDidDismiss,
  backdropDismiss = true,
  children,
  width = "90%",
  maxWidth = "300px",
  borderRadius = "34px",
}: RoundedModalProps) {
  useCloseOnBackButton(isOpen, onDidDismiss, { canClose: backdropDismiss });

  if (!isOpen) return null;

  return createPortal(
    <div className="animate-modal-fade-in fixed inset-0 z-[9999] flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black/40"
        onClick={backdropDismiss ? onDidDismiss : undefined}
      />
      <div className="relative overflow-hidden bg-white" style={{ width, maxWidth, borderRadius }}>
        {children}
      </div>
    </div>,
    document.querySelector("ion-app") ?? document.body,
  );
});
